(function () {
  var CART_FINISHED = 'onCartFinished';
  var refreshTimer = null;

  function groupRoot(el) {
    return el && el.closest('[data-cart-group-keys]');
  }

  function keysFrom(el) {
    var raw = el && el.getAttribute('data-cart-group-keys');
    if (!raw) return [];
    return raw.split(',').map(function (k) { return k.trim(); }).filter(Boolean);
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart request failed: ' + res.status);
      return res.json();
    });
  }

  function syncThemeCart(cart) {
    if (!cart) return cart;
    window.Cart = window.Cart || {};
    window.Cart.data = cart;
    return cart;
  }

  function emitCartFinished(cart) {
    var payload = cart || (window.Cart && window.Cart.data) || null;
    if (window.jQuery) {
      window.jQuery(document).trigger(CART_FINISHED, payload);
    }
    document.dispatchEvent(new CustomEvent(CART_FINISHED, {
      bubbles: true,
      detail: payload ? { cart: payload } : {}
    }));
  }

  function refreshCart(cart) {
    var payload = cart ? syncThemeCart(cart) : null;
    var schedule = function (next) {
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        emitCartFinished(next);
      }, 50);
      return next;
    };

    if (payload) return Promise.resolve(schedule(payload));

    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (fresh) {
        return schedule(syncThemeCart(fresh));
      })
      .catch(function (err) {
        console.error('Cart grouping refresh failed', err);
        schedule(window.Cart && window.Cart.data);
      });
  }

  function updateLines(updates) {
    return postJson('/cart/update.js', { updates: updates }).then(refreshCart);
  }

  function changeLine(payload) {
    return postJson('/cart/change.js', payload);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-remove-group-keys]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var keys = link.getAttribute('data-remove-group-keys').split(',').map(function (k) {
      return k.trim();
    }).filter(Boolean);
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    updateLines(updates).catch(function (err) {
      console.error('Cart grouping remove failed', err);
    });
  }, true);

  document.addEventListener('onQtyChange', function (event) {
    var selector = event.detail && event.detail.qtySelector;
    if (!selector) return;
    var root = groupRoot(selector);
    if (!root) return;
    var keys = keysFrom(root);
    if (!keys.length) return;
    var nextTotal = Number(event.detail.newValue);
    if (isNaN(nextTotal) || nextTotal < 0) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var lines = cart.items.filter(function (item) { return keys.indexOf(item.key) !== -1; });
        var currentTotal = lines.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        var delta = nextTotal - currentTotal;
        var updates = {};

        if (nextTotal === 0) {
          keys.forEach(function (key) { updates[key] = 0; });
          return updateLines(updates);
        }

        if (delta > 0) {
          var first = lines[0];
          if (!first) return;
          updates[first.key] = first.quantity + delta;
          return updateLines(updates);
        }

        if (delta < 0) {
          var remaining = -delta;
          for (var i = lines.length - 1; i >= 0 && remaining > 0; i -= 1) {
            var take = Math.min(lines[i].quantity, remaining);
            updates[lines[i].key] = lines[i].quantity - take;
            remaining -= take;
          }
          return updateLines(updates);
        }
      })
      .catch(function (err) {
        console.error('Cart grouping quantity failed', err);
      });
  });

  function lineGroupId(line, fallback) {
    var props = (line && line.properties) || {};
    if (props._cart_group) return String(props._cart_group);
    if (line && line.selling_plan_allocation) return 'sub';
    return fallback || 'otp';
  }

  function lineProperties(line, groupId) {
    var props = {};
    var source = (line && line.properties) || {};
    Object.keys(source).forEach(function (key) {
      if (source[key] != null && typeof source[key] !== 'object') {
        props[key] = source[key];
      }
    });
    props._cart_group = groupId;
    return props;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    var isCheckbox = target.matches && target.matches('[data-cart-product-recharge-checkbox]');
    var isSelect = target.matches && target.matches('[data-cart-product-recharge-select]');
    if (!isCheckbox && !isSelect) return;

    var groupedRoot = groupRoot(target);
    var keys = groupedRoot ? keysFrom(groupedRoot) : [];
    if (!keys.length) return;

    var root = target.closest('[data-cart-product]');
    if (!root) return;

    event.stopImmediatePropagation();

    var fallbackGroupId = root.getAttribute('data-cart-group-id') || 'otp';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var planId = null;
        if (isCheckbox) {
          if (target.checked) {
            planId = parseInt(root.getAttribute('data-default-subscription-id'), 10) || null;
          }
        } else {
          planId = parseInt(target.value, 10) || null;
        }

        var chain = Promise.resolve();
        var lastCart = null;
        keys.forEach(function (key) {
          var line = cart.items.find(function (item) { return item.key === key; });
          if (!line) return;
          var groupId = lineGroupId(line, fallbackGroupId);
          chain = chain.then(function () {
            return changeLine({
              id: key,
              quantity: line.quantity,
              selling_plan: planId,
              properties: lineProperties(line, groupId)
            }).then(function (nextCart) {
              lastCart = nextCart;
              return nextCart;
            });
          });
        });
        return chain.then(function () { return refreshCart(lastCart); });
      })
      .catch(function (err) {
        console.error('Cart grouping subscribe failed', err);
      });
  }, true);
})();
